import { get, isEmpty } from 'lodash'
import { required, email, requiredCheck } from 'utils/validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

const validate = (values, props = {}) => {
  let errors = {}

  const conductUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.assessorCodeOfConduct.id}].fileUrl`)
  const roleUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.assessorRoleResponsibility.id}].fileUrl`)
  const requirementsUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.assessorRequirements.id}].fileUrl`)
  const isPrivacyPolicyAgreementEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id}].booleanValue`, false)
  const privacyPolicyUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.privacyPolicyUrl.id}].textValue`)

  const helpers = {
    terms: requiredCheck(get(values, 'helpers.terms')),
    agreementCodeOfConduct: conductUrl && requiredCheck(get(values, 'helpers.agreementCodeOfConduct')),
    roleResponsibility: roleUrl && requiredCheck(get(values, 'helpers.roleResponsibility')),
    agreementRequirements: requirementsUrl && requiredCheck(get(values, 'helpers.agreementRequirements')),
    agreementPrivacyPolicy: (isPrivacyPolicyAgreementEnabled && privacyPolicyUrl) && requiredCheck(get(values, 'helpers.agreementPrivacyPolicy')),

  }

  errors = {
    helpers: !isEmpty(helpers) && helpers
  }

  errors.email = required(get(values, 'email')) || email(get(values, 'email'))
  errors.passwordAgain = required(get(values, 'passwordAgain'))

  if (get(values, 'password') && get(values, 'passwordAgain')) {
    if (get(values, 'password') !== get(values, 'passwordAgain')) {
      errors = {
        ...errors,
        passwordAgain: {
          text: "Passwords don't match",
          intlKey: 'errors.passwords_dont_match',
          values: {}
        }
      }
    }
  }

  return errors
}

export default validate
